export const VISUAL_CONFIG_FIELDS = [
  'preset',
  'colorPrimary',
  'colorSecondary',
  'colorTextUpper',
  'colorTextLower',
  'scale',
  'rotation',
  'posX',
  'posY',
  'classicRadius',
  'classicAccentWidth',
  'classicTextPaddingX',
  'minimalNameHeight',
  'minimalTitleHeight',
  'minimalTextPaddingX',
  'modernSkewOffset',
  'modernAccentOffset',
  'modernAccentWidth',
  'modernTextX',
  'templateShapeVisible',
  'templateMainTextVisible',
  'templateSubTextVisible',
  'shapePrimitives',
  'layerOrder',
  'layerLocks',
];

export const clonePreset = (preset) => JSON.parse(JSON.stringify(preset));

export const extractVisualConfigFromPreset = (preset) => {
  if (!preset) return {};
  return {
    preset: preset.preset,
    colorPrimary: preset.colorPrimary,
    colorSecondary: preset.colorSecondary,
    colorTextUpper: preset.colorTextUpper,
    colorTextLower: preset.colorTextLower,
    scale: preset.scale,
    rotation: preset.rotation,
    posX: preset.posX,
    posY: preset.posY,
    classicRadius: preset.classicRadius,
    classicAccentWidth: preset.classicAccentWidth,
    classicTextPaddingX: preset.classicTextPaddingX,
    minimalNameHeight: preset.minimalNameHeight,
    minimalTitleHeight: preset.minimalTitleHeight,
    minimalTextPaddingX: preset.minimalTextPaddingX,
    modernSkewOffset: preset.modernSkewOffset,
    modernAccentOffset: preset.modernAccentOffset,
    modernAccentWidth: preset.modernAccentWidth,
    modernTextX: preset.modernTextX,
    templateShapeVisible: preset.templateShapeVisible,
    templateMainTextVisible: preset.templateMainTextVisible,
    templateSubTextVisible: preset.templateSubTextVisible,
    shapePrimitives: Array.isArray(preset.shapePrimitives)
      ? preset.shapePrimitives.map((shape) => ({ ...shape }))
      : [],
    layerOrder: Array.isArray(preset.layerOrder)
      ? [...preset.layerOrder]
      : [],
    layerLocks: preset.layerLocks && typeof preset.layerLocks === 'object'
      ? { ...preset.layerLocks }
      : {},
  };
};

export const applyPresetToConfig = (config, preset) => ({
  ...config,
  ...extractVisualConfigFromPreset(preset),
});

export const applyPresetToConfigPreservingThemeColors = (config, preset) => {
  const next = applyPresetToConfig(config, preset);
  return {
    ...next,
    colorPrimary: config?.colorPrimary ?? next.colorPrimary,
    colorSecondary: config?.colorSecondary ?? next.colorSecondary,
    colorTextUpper: config?.colorTextUpper ?? next.colorTextUpper,
    colorTextLower: config?.colorTextLower ?? next.colorTextLower,
  };
};

export const generatePresetId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `custom-${crypto.randomUUID()}`;
  }
  return `custom-${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
};

export const duplicatePreset = (preset, nameOverride) => {
  const base = clonePreset(preset);
  return {
    ...base,
    id: generatePresetId(),
    isBuiltIn: false,
    name: nameOverride || `${base.name} Copy`,
    updatedAt: Date.now(),
  };
};

export const upsertCustomPreset = (customPresets, nextPreset) => {
  const exists = customPresets.some((item) => item.id === nextPreset.id);
  if (!exists) return [...customPresets, nextPreset];
  return customPresets.map((item) => (item.id === nextPreset.id ? nextPreset : item));
};
